/* eslint-disable eqeqeq */
import { Dialog, Transition } from "@headlessui/react";
import gravatarUrl from "gravatar-url";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeColor, changeType, setTeamTitle } from "../../features/teams/teamsSlice";
import SuggestPeople from "../combobox/SuggestPeople";
export default function EditTeamModal({
  isOpen,
  handleModal,
  handleUpdateTeam,
  myInfo,
  assigns,
  setAssigns,
  handleRemoveAssign,
  assignsUserInfo,
  error,
  setError,
}) {
  const { team } = useSelector((state) => state.teams);
  const [title, setTitle] = useState(team?.title ?? "");
  const [internalColor, setInternalColor] = useState(team?.color ?? "");
  const [internalType, setInternalType] = useState(team?.type ?? "");
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      setTitle("");
      setInternalColor("");
      setInternalType("")
    };
  }, []);
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[500]" onClose={handleModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-gray-200 p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Update Team
                    <div className="mb-20">
                      <SuggestPeople
                        assigns={assigns}
                        setAssigns={setAssigns}
                      />
                    </div>
                  </Dialog.Title>
                  <div className="flex mt-2 items-center justify-center flex-wrap gap-x-2">
                    <span>Members:</span>
                    {assignsUserInfo?.length > 0 &&
                      assignsUserInfo.map((assign, i) => (
                        <div
                          key={i}
                          className="flex items-center border-gray-300 border-2 p-1  p-[2px] rounded-xl relative z-[299]"
                        >
                          <img
                            className="object-cover w-10 h-10 rounded-full"
                            src={
                              assign?.avt
                                ? assign.avt
                                : gravatarUrl(assign.email, {
                                    size: 80,
                                  })
                            }
                            alt=""
                          />
                          <span className={`px-2`}>{assign.name} </span>
                          {assign.email == myInfo?.email ? (
                            ""
                          ) : (
                            <div
                              className="border-2 text-red-500 px-2 rounded !cursor-pointer"
                              onClick={() => handleRemoveAssign(assign)}
                            >
                              x
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                  <div className="mt-2 py-4">
                    <form
                      className="mt-8 space-y-6"
                      onSubmit={handleUpdateTeam}
                    >
                      <input
                        type="hidden"
                        name="remember"
                        defaultValue="true"
                      />
                      <div className="rounded-md shadow-sm -space-y-px">
                        <div className="mb-4">
                          <p className="py-1"> Team Title</p>
                          <input
                            type="text"
                            value={title}
                            onChange={(e) => {
                              setError("");
                              setTitle(e.target.value);
                              dispatch(setTeamTitle(e.target.value));
                            }}
                            autoComplete="text"
                            required
                            className="appearance-none relative block w-full px-2 py-3 border-2 border-gray-300 placeholder-gray-500 text-gray-900 rounded-xl focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-md"
                            placeholder="Team Title"
                          />
                        </div>
                        <div className="mb-4">
                          <p className="py-2"> Team Type</p>
                          <input
                            type="text"
                            value={internalType}
                            onChange={(e) => {
                              setError("");
                              setInternalType(e.target.value);
                              dispatch(changeType(e.target.value))
                            }}
                            autoComplete="text"
                            required
                            className="appearance-none relative block w-full px-2 py-3 border-2 border-gray-300 placeholder-gray-500 text-gray-900 rounded-xl focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-md"
                            placeholder="Write Team type ex: dev, design, copyright, etc"
                          />
                        </div>
                        <div className="mb-4">
                          <p className="py-2"> color</p>
                          <input
                            type="text"
                            value={internalColor}
                            onChange={(e) => {
                              setError("");
                              setInternalColor(e.target.value);
                              dispatch(changeColor(e.target.value));
                            }}
                            autoComplete="text"
                            required
                            className="appearance-none relative block w-full px-2 py-3 border-2 border-gray-300 placeholder-gray-500 text-gray-900 rounded-xl focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-md"
                            placeholder="Enter Color ex: purple, blue , red , etc"
                          />
                        </div>
                      </div>
                      <div>
                        <button
                          type="submit"
                          className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                        >
                          Team Update
                        </button>
                        <button
                          onClick={handleModal}
                          className="mt-3 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-rose-600 hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                        >
                          Canceled
                        </button>
                      </div>
                    </form>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
